// extracted by css-extract-rspack-plugin
export default {"metricAccordionItem":"eri6N","metricAccordionControl":"D9OZ5","metricAccordionLabel":"m0kVv","metricAccordionPanel":"gE4ze","occurrenceCountBadge":"luuSs"};